function requestAPI(token) {
  return fetch(`${process.env.REACT_APP_ADMIN_URL}setting-referral`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  }).then((res) => res.json())
}

export default function actionGetSettingReferral() {
  return async (dispatch, getState) => {
    dispatch({
      type: 'GET_SETTING_REFERRAL_BEGIN'
    })

    try {
      const token = await getState().auth.authenticate.token
      const result = await requestAPI(token)
      if(!result.status) {
        handleErrors(dispatch, result)
        return
      }

      dispatch({
        type: 'GET_SETTING_REFERRAL_SUCCESS',
        payload: result.data
      })
    } catch (err) {
      handleErrors(dispatch, err)
    }
  }
}

function handleErrors(dispatch, error) {
  dispatch({        
    type: 'GET_SETTING_REFERRAL_FAILURE',        
    error: error    
  })
}
